<template>
  <div class="form-container">
    <h1 class="mb-4">建物種別情報新規作成</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>

      <div class="mb-3">
        <label for="building_typeName" class="form-label">建物種別名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="building_type.building_type_nm" type="text" placeholder="建物種別名" class="form-control" id="building_typeName" required>
        <div v-if="errorMessages.building_type_nm" class="alert alert-danger mt-2">{{ errorMessages.building_type_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="corpNum" class="form-label">並び順 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="building_type.sort_no" type="text" placeholder="並び順" class="form-control" id="sortNo" required>
        <div v-if="errorMessages.sort_no" class="alert alert-danger mt-2">{{ errorMessages.sort_no[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-primary" :disabled="isSubmitting">登録</button>
      </div>

    </form>

    <DuplicateNameConfirmationModal
      :modalId="duplicateModalId"
      message="すでに同名の建物種別名が登録されていますが、本当に作成してもよろしいでしょうか？"
      @confirm="handleDuplicateConfirm"
    />
  </div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Modal } from 'bootstrap';
import { checkBuildingTypeDuplicate, createBuildingType } from '@/api/axios';
import DuplicateNameConfirmationModal from '@/components/shared/DuplicateNameConfirmationModal.vue';

export default {
  components: {
    DuplicateNameConfirmationModal
  },
  setup() {
    const title = ref('建物種別情報新規作成');

    watchEffect(() => {
      document.title = title.value;
    });

    const building_type = ref({
      building_type_nm: '',
      sort_no: ''
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});
    const isSubmitting = ref(false);
    const duplicateModalId = 'duplicateBuildingTypeCreateModal';

    const store = useStore();
    const router = useRouter();

    const showDuplicateModal = () => {
      const modalElement = document.getElementById(duplicateModalId);
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.show();
    };

    const saveBuildingType = async () => {
      if (isSubmitting.value) return;

      try {
        isSubmitting.value = true;
        await createBuildingType(building_type.value);
        store.commit('setFlashMessage', {message: '建物種別情報作成完了！', type: 'success'});
        router.push(`/building-types`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '建物種別情報作成失敗！', type: 'danger'});
        console.error('作成エラー:', error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const handleSubmit = async () => {
      if (isSubmitting.value) return;

      try {
        isSubmitting.value = true;
        const response = await checkBuildingTypeDuplicate(building_type.value.building_type_nm);
        if (response.data?.duplicate) {
          showDuplicateModal();
          return;
        }
      } catch (error) {
        console.error('重複チェックエラー:', error);
      } finally {
        isSubmitting.value = false;
      }

      await saveBuildingType();
    };

    const handleDuplicateConfirm = async () => {
      await saveBuildingType();
    };

    return {
      title,
      building_type,
      handleSubmit,
      handleDuplicateConfirm,
      errorMessages,
      isSubmitting,
      duplicateModalId
    };
  }
};
</script>

<style scoped>
.form-container {
  padding: 20px;
  width: 70%;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 4px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.btn-area{
  text-align: center;
}
</style>
